module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list_box2",
    attrs: {
      "id": "home_notice"
    }
  }, [_c('table', [_vm._l((_vm.notices), function(notice, index) {
    return (notice.isTop) ? _c('tr', {
      key: index,
      staticStyle: {
        "border-bottom": "#ddd 1px dashed"
      }
    }, [_c('th', {
      staticStyle: {
        "padding": "16px 0",
        "width": "100px"
      }
    }, [_vm._v(_vm._s(notice.sDate && notice.sDate.split(' ')[0]))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "padding": "16px 0"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px 0"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ann_page',
          params: {
            newsid: notice.id
          }
        }
      }
    }, [_vm._v(_vm._s(notice.title)), _c('img', {
      attrs: {
        "src": "/../static/images/stickyPin.png"
      }
    })])], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.notices), function(notice, index) {
    return (!notice.isTop) ? _c('tr', {
      key: index,
      staticStyle: {
        "border-bottom": "#ddd 1px dashed"
      }
    }, [_c('th', {
      staticStyle: {
        "padding": "16px 0",
        "width": "100px"
      }
    }, [_vm._v(_vm._s(notice.sDate && notice.sDate.split(' ')[0]))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "padding": "16px 0"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px 0"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ann_page',
          params: {
            newsid: notice.id
          }
        }
      }
    }, [_vm._v(_vm._s(notice.title))])], 1)]) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-665f77a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rent/HomeNotice.vue
// module id = 1247
// module chunks = 3